"use client";

import { c as _c } from "react/compiler-runtime";
import type { GmailMatchResult } from "@/lib/workflow/gmailQuery";
interface GmailMatchBadgeProps {
  result: GmailMatchResult;
}
export function GmailMatchBadge(t0) {
  const $ = _c(12);
  const {
    result
  } = t0;
  if (!result.hasConfiguredFilter) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="border-ds-border-default dark:bg-ds-neutral-900/40 rounded-lg border bg-zinc-50 px-3 py-2"><p className="body-sm text-ds-text-subtle">No Gmail search query configured — every new email will trigger this workflow.</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== result.fields || $[2] !== result.matches) {
    t1 = result.matches ? <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 dark:border-emerald-900/60 dark:bg-emerald-950/30"><p className="body-sm-semibold text-emerald-700 dark:text-emerald-300">Matches your search — this sample would trigger the workflow.</p>{result.fields.length > 0 && <ul className="mt-1 space-y-0.5">{result.fields.map(_temp)}</ul>}</div> : <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 dark:border-amber-900/60 dark:bg-amber-950/30"><p className="body-sm-semibold text-amber-800 dark:text-amber-200">Wouldn’t trigger in production — this sample doesn’t match your search.</p><ul className="mt-1 space-y-0.5">{result.fields.map(_temp2)}</ul></div>;
    $[1] = result.fields;
    $[2] = result.matches;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const body = t1;
  let t2;
  if ($[4] !== result.unsupported) {
    t2 = result.unsupported.length > 0 && <p className="caption-xs text-ds-text-muted">Operators not previewable: {result.unsupported.map(_temp3).join(", ")}. Actual matching runs in Gmail and may differ.</p>;
    $[4] = result.unsupported;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== result.unsupported.length) {
    t3 = result.unsupported.length === 0 && <p className="caption-xs text-ds-text-muted py-2">Preview only. Actual matching runs in Gmail and may differ slightly.</p>;
    $[6] = result.unsupported.length;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== body || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className="space-y-1.5">{body}{t2}{t3}</div>;
    $[8] = body;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp3(o) {
  return `"${o}"`;
}
function _temp2(f_0, i_0) {
  return <li key={`${f_0.operator}-${i_0}`} className="caption-xs text-amber-800/80 dark:text-amber-200/80"><span className="font-medium">{f_0.operator}</span> “{f_0.filter}” {f_0.ok ? "found" : "not found"}{f_0.field === "(any)" ? " in any field" : <>{" "}in {f_0.field} “{f_0.value || "(empty)"}”</>}</li>;
}
function _temp(f, i) {
  return <li key={`${f.operator}-${i}`} className="caption-xs text-emerald-700/80 dark:text-emerald-300/80"><span className="font-medium">{f.operator}</span> “{f.filter}” found in{" "}{f.field === "(any)" ? "any field" : f.field}</li>;
}